import { render, staticRenderFns } from "./CoinLogs.vue?vue&type=template&id=dd76da88&scoped=true"
import script from "./CoinLogs.vue?vue&type=script&lang=ts"
export * from "./CoinLogs.vue?vue&type=script&lang=ts"
import style0 from "./CoinLogs.vue?vue&type=style&index=0&id=dd76da88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd76da88",
  null
  
)

export default component.exports